import React from 'react';
import './Footer.css';  
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
    return (
        <footer className="footer">
            <Container fluid >
                <Row className='footer-content'>
                    
                    <Col md={10}></Col> 
                    <Col md={2} className="text-end">
                        <span>© 2024 All rights reserved</span>
                    </Col>
                    
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
